import { createAction, props } from '@ngrx/store';
import { IDataGetmTienda } from '../../private/shared/models/productos';

export const getGetmTienda = createAction(
    '[GetmTienda] Get Getm Tienda'
);

export const successGetmTienda = createAction(
    '[GetmTienda] Success Getm Tienda',
    props<{ data: IDataGetmTienda }>()
);

export const errorGetmTienda = createAction(
    '[GetmTienda] Error Getm Tienda',
    props<{ payload: any }>()
);

export const resetGetmTienda = createAction(
    '[GetmTienda] Reset Getm Tienda'
);
